import { useNavigate } from "react-router-dom";

import { SkinSun } from "../components/SkinSun";
import { usePersonalisationData } from "../context/PersonalisationDataContext";
import { usePersonalisationLeave } from "../context/PersonalisationLeaveContext";

import { SkinBalanceContainer_PATH } from "./SkinBalanceContainer";
import { SkinColorContainer_PATH } from "./SkinTypeContainer";

export const SkinSunContainer_PATH = "/personalise/skin-sun" as const;

export function SkinSunContainer() {
  const navigate = useNavigate();
  const { skinSun, setSkinSunAnswered, skipSkinSun } = usePersonalisationData();
  const { openConfirmLeave } = usePersonalisationLeave();
  return (
    <SkinSun
      progressPercentage={68}
      initialSelectedId={skinSun.state === "answered" ? skinSun.value : null}
      onContinue={(selection) => {
        setSkinSunAnswered(selection);
        navigate(SkinBalanceContainer_PATH);
      }}
      onSkip={() => {
        skipSkinSun();
        navigate(SkinBalanceContainer_PATH);
      }}
      onBack={() => navigate(SkinColorContainer_PATH)}
      onClose={openConfirmLeave}
    />
  );
}
